module.exports = __webpack_public_path__ + "static/media/stopwatch_blue.c7362aae.svg";